import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

// Lightweight public fetch of editable site content (settings). Cached per mount.
export function useSiteContent() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setContent(r.data || {})).catch(() => setContent({}));
  }, []);
  return content;
}
